/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filter': {
    width: 29,
    height: 32,
    viewBox: '0 0 29 32',
    data: '<path pid="0" _fill="#fff" d="M29 0v7.248L18.678 18.506V32l-8.356-4.908v-8.586L0 7.248V0zM2.458 2.502v2.501h24.084V2.502zm22.944 5.003H3.598L12.78 17.52v8.127l3.44 2.021V17.52z"/>'
  }
})
